import { render, staticRenderFns } from "./VaSelectCustomize.vue?vue&type=template&id=2ede4cac&"
import script from "./VaSelectCustomize.vue?vue&type=script&lang=js&"
export * from "./VaSelectCustomize.vue?vue&type=script&lang=js&"
import style0 from "./VaSelectCustomize.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports